import { findElement } from './fieldUtils';
import shouldResetToDefaultValue from './shouldResetToDefaultValue';
export default function checkDynamicFieldChange(defaultElements, currentElements, nextElements) {
  const changedFields = (nextElements || []).reduce((changedFields, nextElement) => {
    const defaultElement = findElement(defaultElements, nextElement.id);
    const currentElement = findElement(currentElements, nextElement.id);
    if (!currentElement || !defaultElement) {
      return changedFields;
    }
    if (nextElement.elementType === 'fieldGroupInstance') {
      return [...changedFields, ...checkDynamicFieldChange(defaultElements, currentElements, nextElement.elements)];
    }
    if (defaultElement.elementType === 'fieldInstance' && currentElement.elementType === 'fieldInstance' && shouldResetToDefaultValue(defaultElement, currentElement, nextElement)) {
      return [...changedFields, {
        ...nextElement,
        value: defaultElement.value
      }];
    }
    return changedFields;
  }, []);
  return changedFields;
}